import { isDefined } from "csi/utility/coreUtility";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import CheckboxOption from "./CheckboxOption";
import { ICustomViewQueryOptions } from "./CustomViewOptions";
import { CustomViewQueryOptionsStore } from "./CustomViewQueryOptionsStore";

const FilterOptions: FunctionComponent = observer((props) => {
	const { optionsStore } = useCustomViewDialogStore();
	const store = optionsStore as CustomViewQueryOptionsStore; 

	const { 
		setDisableAdHoc,
		setFilterRemember, 
		setShowCountIfSuspended, 
		setSuspended,
		setSuspendedRequireFilter,
		options,
	} = store;

	const {
		disableAdHoc,
		filterRemember,
		showCountIfSuspended,
		suspended,
		suspendedRequireFilter,
	} = options as ICustomViewQueryOptions;

	return (
		<>
			{isDefined(disableAdHoc) && (
				<>
					<CheckboxOption
						dataCsiAutomation="CustomViewEnableAdHocFilters"
						label="CustomViewEnableAdHocFilters"
						onChange={(e, value) => setDisableAdHoc(!value)}
						optionValue={!disableAdHoc}
						paddingLeft={0}
					/>
					<CheckboxOption
						dataCsiAutomation="CustomViewRememberAdHocFilters"
						hidden={disableAdHoc}
						label="CustomViewRememberAdHocFilters"
						onChange={(e, value) => setFilterRemember(value)}
						optionValue={filterRemember}
						paddingLeft={6}
					/>
					<CheckboxOption
						dataCsiAutomation="CustomViewShowCountAdHocFilters"
						hidden={disableAdHoc}
						label="CustomViewShowCountAdHocFilters"
						onChange={(e, value) => setShowCountIfSuspended(value)}
						optionValue={showCountIfSuspended}
						paddingLeft={6}
					/>
					<CheckboxOption
						dataCsiAutomation="CustomViewLoadResultsOnlyRequestAdHocFilters"
						hidden={disableAdHoc}
						label="CustomViewLoadResultsOnlyRequestAdHocFilters"
						onChange={(e, value) => setSuspended(value)}
						optionValue={suspended}
						paddingLeft={6}
					/>
					<CheckboxOption
						dataCsiAutomation="CustomViewRequireOneAdHocFilters"
						hidden={disableAdHoc || !suspended}
						label="CustomViewRequireOneAdHocFilters"
						onChange={(e, value) => setSuspendedRequireFilter(value)}
						optionValue={suspendedRequireFilter}
						paddingLeft={13}
					/>
				</>
			)}
		</>
	);
});

export default FilterOptions;